import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 8055 12075"
    {...props}
  >
    <path
      d="M4074 4556c679-15 1324-30 1968-44l714-15c41-1 82-1 123 2 133 11 281 17 339 161 57 138-35 250-129 337-369 349-743 692-1117 1036-589 541-1180 1081-1771 1622-33 30-69 57-93 119 47 4 93 9 139 10 265 9 530 16 795 28 54 3 109 18 159 39 126 55 169 164 91 279-65 97-150 185-241 258-1478 1168-2959 2334-4440 3499-86 67-180 126-278 172-92 43-151-6-122-104 34-117 85-231 144-338 540-996 1084-1991 1626-2985 26-48 49-96 83-164-66-2-114-6-163-7-484-2-969-2-1454-8-123-2-269-7-315-144-46-138 70-231 168-303 627-461 1256-917 1884-1374 278-202 556-402 834-604 35-25 68-54 131-103h-177c-782 0-1565 1-2347-2-95 0-193-5-285-26-279-64-399-277-312-549 30-90 76-177 124-259C989 3673 1825 2256 2667 842 2995 291 3493 10 4131 5c1125-9 2250-3 3376-2 100 1 202 6 300 28 239 53 313 220 187 430-53 89-125 169-198 244-1205 1246-2411 2491-3618 3736-28 29-54 59-104 115z"
      style={{
        fill: "#000",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
